import React, { useState, useEffect } from "react";
import axios from "axios";
import { login } from "../../auth/auth";
import { useNavigate } from "react-router-dom";
import closeMenuIcon from "../../assets/images/bg-close-button.png";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SelectTopic = ({ handleSelectMenu }) => {
  const [authToken, setAuthToken] = useState("");
  const [topics, setTopics] = useState([]);
  const [avatars, setAvatars] = useState([]);
  const [selectedPassphrase, setSelectedPassphrase] = useState("");
  const [showAvatarsMenu, setShowAvatarsMenu] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to login:", error);
      }
    };

    performLogin();
  }, []);

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/key`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        setTopics(response.data.data);
        console.log("Topics:", response.data.data);
      } catch (error) {
        console.error("Failed to fetch topics:", error);
      }
    };

    if (authToken) {
      fetchTopics();
    } else {
      console.log("No authToken available");
    }
  }, [authToken]);

  useEffect(() => {
    const fetchAvatars = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/config/passphrase/${selectedPassphrase}/language/English`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        setAvatars(response.data.data);
        console.log("Avatars:", response.data.data);
      } catch (error) {
        console.error("Failed to fetch avatars:", error);
      }
    };

    if (selectedPassphrase) {
      fetchAvatars();
    }
  }, [selectedPassphrase, authToken]);

  const handleTopicSelect = (passphrase) => {
    setSelectedPassphrase(passphrase);
    setShowAvatarsMenu(true);
  };

  const handleAvatarClick = (avatar) => {
    const { key, avatar: avatarData, app, language } = avatar;

    const passphrase = key.passphrase;
    const config_id = avatar.id;
    const appId = app.id;
    const lang = language;

    sessionStorage.setItem("passphrase", passphrase);
    sessionStorage.setItem("config_id", config_id);
    sessionStorage.setItem("appId", appId);
    sessionStorage.setItem("language", lang);
    sessionStorage.setItem("topic", key.name);
    sessionStorage.setItem("avatar", avatar.name);

    navigate(`/avatar/${avatar.name}`, {
      state: {
        passphrase,
        config_id,
        appId,
        language: lang,
      },
    });
  };

  return (
    <div className="Menu">
      <div className="navbar">
        <div className="close-menu" style={{ visibility: "hidden" }}>
          <img src={closeMenuIcon} alt="Close Menu" />
        </div>
        <div className="menu__title">
          <p>{!showAvatarsMenu ? "Select Topic" : "Select Avatar"}</p>
        </div>
        <div className="close-menu">
          <img
            src={closeMenuIcon}
            alt="Close menu"
            onClick={handleSelectMenu}
          />
        </div>
      </div>

      {/* Select Topic */}
      {!showAvatarsMenu && (
        <div className="menu__content select-topic__content">
          {topics.length > 0 ? (
            topics.map((topic) => (
              <div
                key={topic.id}
                className="menu__item select-topic__button"
                onClick={() => handleTopicSelect(topic.passphrase)}
              >
                <p>{topic.name}</p>
              </div>
            ))
          ) : (
            <p>Loading topics...</p>
          )}
        </div>
      )}

      {/* Select Avatar */}
      {showAvatarsMenu && (
        <div className="menu__content-submenu select-avatar__content">
          {avatars.length > 0 ? (
            avatars.map((avatar) => {
              const imgSrc = avatar?.avatar?.hyperlink
                ? `${BASE_URL}${avatar.avatar.hyperlink.replace(/\\/g, "/")}`
                : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWN8hLKJungcUipWLReON9fse4yZcyB0rzNw&s";
              console.log("Image Source:", imgSrc);

              return (
                <div
                  key={avatar.id}
                  className="menu__avatar-item select-avatar__button"
                  onClick={() => handleAvatarClick(avatar)}
                >
                  <div className="avatar-container">
                    <img src={imgSrc} alt={avatar.name + " avatar"} />
                  </div>
                  <p>{avatar.name}</p>
                </div>
              );
            })
          ) : (
            <p>Loading avatars...</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectTopic;
